import React, { FC } from 'react';
import classnames from 'classnames';
import { IOuter } from './UploadingFileThumbnail.types';
import styles from './UploadingFileThumbnail.scss';
import { useUploadingFileProps } from './useUploadingFileProps';
import { useThumbnailLoadedAndOrientation } from './useThumbnailLoadedAndOrientation';

export const UploadingFileThumbnail: FC<IOuter> = ({ className, fallbackImageClassName, onClick, uploadingFile }) => {
  const { src, file, mediaType, Thumbnail } = useUploadingFileProps(uploadingFile);
  const { isThumbnailLoaded, orientation } = useThumbnailLoadedAndOrientation({ src, file, mediaType });

  return (
    <div onClick={onClick} className={classnames(styles.thumbnail, { [styles.loaded]: isThumbnailLoaded }, className)}>
      <Thumbnail src={src} fallbackImageClassName={fallbackImageClassName} orientation={orientation} />
    </div>
  );
};
